import { AdvanceTable, DangerAlert, IconTextButton, Modal } from 'ui-lib';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IDeviceTableProps } from './components';
import devicesCss from './devices.css';
import { TableUtils } from 'pages/private/components/table-utils';
import { DeviceFileTransferExecutionResultDto } from 'dto/file-transfer.dto';
import { DEFAULT_HISTORICAL_RANGE } from 'common-utils/date-utils';
import { ConstrainedDateRangePicker } from 'pages/private/components/constrained-date-range-picker';
import { DeviceFileTransferExecutionsHistoryStore } from 'store/device-details/file-transfer-executions-history.store';
import { useDeviceStore } from 'store';

export const FileTransferExecutionsTable = observer((props: IDeviceTableProps) => {
    const devicesStore = useDeviceStore();
    const memoizedStore = React.useMemo(() => {
        const store = new DeviceFileTransferExecutionsHistoryStore({
            accountId: props.accountId,
            uid: props.uid,
            devicesStore: devicesStore,
            serialNumber: props.serialNumber,
        });
        store.initialize();
        return store;
    }, []);

    const [modalVisible, setModalVisible] = React.useState<boolean>(false);
    const [modalSource, setModalSource] = React.useState<DeviceFileTransferExecutionResultDto>();

    const handleCancel = () => {
        setModalVisible(false);
    };

    const collectData = (record: DeviceFileTransferExecutionResultDto) => {
        setModalVisible(true);
        setModalSource(record);
    };

    return (
        <div className={devicesCss.tabPane}>
            {memoizedStore.error != undefined && <DangerAlert closable={false} message='Error' description={memoizedStore.error} />}
            <AdvanceTable
                title=''
                table={{
                    dataSource: memoizedStore.fileTransferExecutions,
                    columns: [
                        TableUtils.createBasicFilterColumn({
                            key: 'job_id',
                            title: 'Job Id',
                            columnExtraOptions: {
                                render: (value: string, record: DeviceFileTransferExecutionResultDto) => {
                                    return (
                                        <IconTextButton
                                            type='link'
                                            onClick={() => {
                                                collectData(record);
                                            }}
                                            label={value}
                                        />
                                    );
                                },
                            },
                        }),
                        TableUtils.createBasicFilterColumn({ key: 'status', title: 'Status' }),
                        TableUtils.createBasicFilterTimeColumn({ key: 'createdAt', title: 'Created at' }),
                    ],
                }}
                loadingState={memoizedStore.loading}
                toolbar={{
                    onReload: () => memoizedStore.fetchLatestData(true),
                    extraItems: [
                        <ConstrainedDateRangePicker
                            key="date-range-picker"
                            range={DEFAULT_HISTORICAL_RANGE}
                            setFilterByDateFrom={(filterByDateFrom: Date) => memoizedStore.setFilterByDateFrom(filterByDateFrom)}
                            setFilterByDateTo={(filterByDateTo: Date) => memoizedStore.setFilterByDateTo(filterByDateTo)}
                            filterByDateFrom={memoizedStore.filterByDateFrom}
                            filterByDateTo={memoizedStore.filterByDateTo}
                            loading={memoizedStore.loading}
                            onLoad={() => memoizedStore.fetchLatestData(true)}
                        />,
                    ],
                }}
            />
            <Modal
                isVisible={modalVisible}
                isClosable={true}
                onCancel={handleCancel}
                width={1000}
                extraProps={{ footer: null }}
            >
                <div className={devicesCss['log-content']}>
                    <pre>{JSON.stringify(modalSource?.toJson(), null, 2)}</pre>
                </div>
            </Modal>
        </div>
    );
});
